import { useMemo } from "react";
import { AUTH_TOKEN_KEY } from "../constants/appConstants";
import jwtDecode from "jwt-decode";
import { getCurrentTimezone } from "../utils/timezone";

const useJwtToken = () => {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);

    const { user, isExpired, isValid } = useMemo(() => {
        if (!token || token.length === 0) {
            return {
                user: null,
                isExpired: true,
                isValid: false,
            };
        }

        try {
            const decoded = jwtDecode(token);
            console.log('[useJwtToken] token:', token);
            console.log('🔓 [useJwtToken] Decoded token:', decoded);
            console.log('🌍 [useJwtToken] JWT timezone:', decoded?.timeZone);
            console.log('🌍 [useJwtToken] JWT timezone field:', decoded?.timezone);
            console.log('📋 [useJwtToken] Tüm JWT alanları:', Object.keys(decoded));
            console.log('🌍 [useJwtToken] Cihaz timezone:', getCurrentTimezone());

            const expired = Date.now() > decoded.exp * 1000;
            console.log('⏰ [useJwtToken] Token süre kontrolü:', Date.now(), decoded.exp * 1000, expired);

            const mappedUser = !expired
                ? {
                    id: decoded?.id,
                    firstName: decoded?.firstName,
                    lastName: decoded?.lastName,
                    userType: decoded?.userType,
                    roleId: decoded?.userRoleId,
                    token,
                    timeZone: decoded?.timeZone || decoded?.timezone || getCurrentTimezone(),
                }
                : null;

            return { user: mappedUser, isExpired: expired, isValid: true };
        } catch (err) {
            console.log('💥 [useJwtToken] Token decode hatası:', err);
            return { user: null, isExpired: true, isValid: false };
        }
    }, [token]);

    const getDecodedToken = () => {
        return user;
    };

    const isTokenExpired = () => {
        return isExpired;
    };

    const isTokenValid = () => {
        return isValid;
    };

    const clearStore = () => {
        localStorage.clear();
    };

    return { token, getDecodedToken, isTokenExpired, isTokenValid, clearStore };
};

export default useJwtToken;